export const ResizeMobileMixin = (width) => ({
    data() {
        return {
            showMobileVersion: false
        }
    },
    methods: {
        resizeListenerMobile() {
            this.showMobileVersion = window.innerWidth < width;
        }
    },
    mounted() {
        this.resizeListenerMobile();
        window.addEventListener('resize', this.resizeListenerMobile);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeListenerMobile);
    }
});


// WEBPACK FOOTER //
// ./src/mixins/ResizeMobileMixin.js